import {
    IPublicClientApplication,
    createStandardPublicClientApplication,
    EventType,
    EventMessage,
    AccountInfo,
    InteractionRequiredAuthError,
    BrowserAuthError,
    BrowserAuthErrorCodes,
    CacheLookupPolicy,
} from "@azure/msal-browser";
import config, { isMsal, loginRequest } from "../config";

async function createInstance(): Promise<IPublicClientApplication> {
    const instance = await createStandardPublicClientApplication({
        auth: { ...config.msal, clientId: config.msal.clientId! },
    });

    await instance.handleRedirectPromise();

    if (!instance.getActiveAccount() && instance.getAllAccounts().length > 0) {
        instance.setActiveAccount(instance.getAllAccounts()[0]);
    }

    instance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS) {
            const payload = event.payload as { account?: AccountInfo } | null;
            if (payload?.account) {
                instance.setActiveAccount(payload.account);
            }
        }
    });

    return instance;
}

export const msalReady: Promise<IPublicClientApplication> | null = isMsal ? createInstance() : null;

export async function getAccessToken(): Promise<string> {
    if (!isMsal) {
        return localStorage.getItem("token") || "";
    }

    const instance = await msalReady!;

    const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];

    try {
        const { accessToken } = await instance.acquireTokenSilent({
            ...loginRequest,
            account,
            cacheLookupPolicy: CacheLookupPolicy.AccessTokenAndRefreshToken,
        });

        localStorage.setItem("token", accessToken);

        return accessToken;
    } catch (error) {
        if (error instanceof InteractionRequiredAuthError || (error instanceof BrowserAuthError && error.errorCode === BrowserAuthErrorCodes.noAccountError)) {
            localStorage.removeItem("token");
            await instance.acquireTokenRedirect({
                ...loginRequest,
                account,
                redirectStartPage: window.location.href,
            });
        }

        throw error;
    }
}
